import React from "react";
import PropTypes from "prop-types";

function CollectionSubTitleItem({ value }) {
    return (
        <div className="CollectionCortisSubTitle">
            <p className="CollectionCortisSubTitle-text">{value}</p>
        </div>
    );
}

CollectionSubTitleItem.propTypes = {
    value: PropTypes.string.isRequired,
};

export default React.memo(CollectionSubTitleItem);
